<template>
    <double-bounce />
</template>
<script>
import {DoubleBounce} from 'vue-loading-spinner';
export default {
  name: "LoadingSpin",
  components: {DoubleBounce}
};
</script>